/* eslint camelcase: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputField } from 'shared-components/inputs/input-field';
import TextField from '../app-main/components/reduxForms/fields/TextField/TextField';
import { DropDownBtn } from '../elements-dropdown/dropdown-btn';
import { getWebEnv } from '../../../api/api-env';
import _ from 'lodash';
import { injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from "shared-components/hocs/sharedIntlProviderHOC";
import classNames from 'classnames';

class Payment extends Component {
  constructor (props) {
    super(props);
    this.renderTitle = this.renderTitle.bind(this);
    this.formattedCC = this.formattedCC.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
    this.listContent = this.listContent.bind(this);
    this.getValueFromInput = this.getValueFromInput.bind(this);
    this.validateInput = this.validateInput.bind(this);

    this.state = {
      dropDataValue: null,
      dropShownValue: null,
      showForm: false,
      paymentInfo: [{ addNew: this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.payment.add_card', defaultMessage: 'Add a new card' }) }],
      formInputs: [
        {
          inputFieldName: 'cardholders_name',
          elementID: 'cardholders_name',
          ref: 'cardholdersName',
          placeholder: this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.payment.cardholders_name', defaultMessage: 'Cardholder\'s Name' }),
          actionFn: this.getValueFromInput,
          actionCb: this.validateInput,
          optional: false
        }
      ]
    };
  }

  componentWillMount () {
    const { paymentInfo } = this.props;
    if (0 < paymentInfo.length) {
      const selectedCard = this.props.selectedCard || paymentInfo[0];
      const dropShownValue = this.formattedCC(selectedCard);
      const newPaymentInfo = _.uniq(paymentInfo.concat(this.state.paymentInfo));
      this.setState({
        dropShownValue,
        paymentInfo: newPaymentInfo
      });
    } else {
      this.setState({
        dropShownValue: this.state.paymentInfo[0].addNew,
        showForm: true
      });
    }
  }

  componentDidMount () {
    const { intl, stripeElementChange } = this.props;
    const locale = intl.locale;
    const localeCode = locale.split('-')[0];
    getWebEnv(locale, (env) => {
      const stripePublicKey = _.get(env, 'stripe.stripe_public_key', '');
      const stripe = Stripe(stripePublicKey, {
        locale: localeCode
      });
      const elements = stripe.elements();

      const card = elements.create('card', {
        classes: {
          base: 'stripe-input form-control input-group',
          empty: 'stripe-input-empty',
          invalid: 'input-error',
          focus: 'stripe-input-focus'
        },
        style: {
          base: {
            fontFamily: 'Avenir-Roman',
            fontSize: '16px',
            color: '#414141',
            '::placeholder': {
              color: '#CED2DA'
            }
          }
        }
      });
      if (stripeElementChange) {
        card.on('change', stripeElementChange);
      }
      card.mount('#card-element');

      this.props.returnStripeCardInstance(card, stripe);
    });
  }

  getValueFromInput (data, cb) {
    const { actionFn } = this.props;
    actionFn(data);
    cb();
  }

  validateInput (errorData, validState) {
    return validState(errorData);
  }

  isValid () {
    return Object.keys(this.refs).map((input) => {
      const { isValid } = this.refs[input] || {};

      if ('function' === typeof(isValid)) {
        return isValid();
      }

      return true;
    }).every((element) => !!element);
  }

  formattedCC (card) {
    const { brand, last4, exp_month, exp_year, addNew } = card;

    if (addNew) {
      return `${addNew}`;
    }

    return `${brand} - ${last4} (Exp. ${exp_month}/${exp_year})`;
  }

  handleListClick (dataValue, closeFn) {
    // Add new card functionality
    if (JSON.parse(dataValue).addNew) {
      this.props.handleListClickCb(false, () => {
        this.setState({ showForm: true, dropShownValue: this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.payment.add_new_card', defaultMessage: 'Add a new card' }) });
      });

      return closeFn();
    }

    const creditCard = this.formattedCC(JSON.parse(dataValue));
    this.setState({ showForm: false, dropShownValue: creditCard });

    this.props.handleListClickCb(dataValue);

    return closeFn();
  }

  listContent (card) {
    return this.formattedCC(card);
  }

  renderTitle () {
    const { title, subtitle, useBootstrapGrid } = this.props;
    const { showForm } = this.state;
    const subtitleContent = subtitle ? <p>{subtitle}</p> : null;

    if (title) {
      return (
        <div className={classNames({ 'col-md-12': this.props.useBootstrapGrid })}>
          <h4>{ title }</h4>
          {
            showForm && subtitleContent
          }
        </div>
      );
    } else if (subtitle) {
      return (
        <div className={classNames({ 'col-md-12': this.props.useBootstrapGrid })}>
          {
            showForm && subtitleContent
          }
        </div>
      );
    }

    return null;
  }

  renderForm () {
    const { formInputs, paymentInfo, showForm } = this.state;
    const { inReduxForm, useBootstrapGrid } = this.props;
    return (
      <div>
        { this.props.newCardOnly ?
          null
          :
          <div className={classNames({ 'col-md-12': useBootstrapGrid })}>
            <DropDownBtn
              containerClassName="bookings"
              buttonClassName="bookings"
              listClassName={classNames('bookings', { 'col-md-12': useBootstrapGrid })}
              listData={paymentInfo}
              listKey="card"
              buttonDataValue={this.state.dropDataValue}
              buttonShownValue={this.state.dropShownValue}
              listClick={this.handleListClick}
              listPreferred={[]}
              listContent={this.listContent}
            />
          </div>
        }
        { showForm && inReduxForm ?
          <div className={classNames({ 'col-md-12': useBootstrapGrid })}>
            <TextField
              className="has-feedback"
              placeholder={this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.payment.cards_name', defaultMessage: 'Cardholder\'s Name' })}
              actionFn={this.getValueFromInput}
              actionCb={this.validateInput}
              {...this.props}
            />
          </div> : showForm ?
            formInputs.map((input, i) => (
              <div style={this.props.useBootstrapGrid ? {
                width: 'calc(100% + 30px)',
                transform: 'translateX(-15px)'
              } : null}>
                <InputField
                  ref={`card-input ${i}`}
                  key={`payment-${i}`}
                  useBootstrapGrid={this.props.useBootstrapGrid}
                  {...input}
                />
              </div>
            ))
            : null
        }
        <div className={showForm
          ? classNames('margin-lg-top', { 'col-xs-12': useBootstrapGrid })
          : 'hide'
        }>
          <div id="card-element" />

          <div id="card-errors" role="alert" />
        </div>
      </div>
    );
  }

  render () {
    return (
      <div
        className={classNames('payment-wrapper', {
          [this.props.bootstrapColClass]: this.props.useBootstrapGrid
        })}
      >
        {this.renderTitle()}
        {this.renderForm()}
      </div>
    );
  }
}

Payment.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actionFn: PropTypes.func,
  handleListClickCb: PropTypes.func,
  selectedCard: PropTypes.object,
  paymentInfo: PropTypes.array,
  returnStripeCardInstance: PropTypes.func,
  newCardOnly: PropTypes.bool,
  bootstrapColClass: PropTypes.string,
  inReduxForm: PropTypes.bool,
  intl: intlShape,
  useBootstrapGrid: PropTypes.bool,
};

Payment.defaultProps = {
  paymentInfo: [],
  newCardOnly: false,
  bootstrapColClass: 'col-lg-9',
  useBootstrapGrid: true
};

exports.Payment = injectIntl(Payment);
